import React from "react";
import { SCROLL_OFFSET, H2, BODY, CONTAINER } from "./sections";

const WhyItChangesSection = () => {
  return (
    <section
      id="why-it-changes"
      style={{ scrollMarginTop: `${SCROLL_OFFSET}px` }}
      className="w-full"
    >
      <div
        className={`${CONTAINER} pt-[64px] pb-[64px] md:pt-[88px] md:pb-[88px] lg:pt-[112px] lg:pb-[112px]`}
      >
        <h2 className={`${H2} text-center`}>Why It Changes How You Write</h2>

        <div className="mx-auto mt-[25.76px] flex max-w-[700px] flex-col gap-[25.76px] text-center">
          <p className={BODY}>
            When you type, you&apos;re constantly switching between thinking
            about what you want to say and physically entering the words.
          </p>
          <p className={BODY}>
            Voice typing can make that process more conversational.
          </p>
          <p className={BODY}>
            You can explain an idea naturally, capture your thoughts quickly,
            and then use AI-powered tools to turn the rough input into cleaner
            writing, or keep it raw when that&apos;s all you need.
          </p>
        </div>

        {/* Takeaway callout */}
        <div className="mx-auto mt-[30.05px] max-w-[840px] rounded-[17.17px] border-[1.34px] border-[#3AB1F633] bg-[#EBF7FE] px-[20px] py-[24px] text-center sm:px-[34.34px] sm:py-[30.05px]">
          <p className="font-jakarta text-[17px] font-bold leading-[28px] tracking-[0px] text-[#3AB1F6] sm:text-[19px] sm:leading-[30px]">
            The biggest benefit isn&apos;t typing faster. It&apos;s reducing the
            friction between having an idea and getting it onto the screen.
          </p>

          <p className="mx-auto mt-[12.88px] max-w-[640px] font-inter text-[13px] font-normal leading-[24px] tracking-[0px] text-[#0A0D1699]">
            For longer emails, reports, notes, documents, and other written
            content, that can make a noticeable difference in how you approach
            writing.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhyItChangesSection;
